import PageLiveDocIcon from '@atlaskit/icon-lab/core/page-live-doc';
import DatabaseIcon from '@atlaskit/icon/core/database';
import PageIcon from '@atlaskit/icon/core/page';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';

export const contentTypeConfiguration = {
	page: {
		tooltip: 'Page',
		icon: PageIcon,
	},
	'live-doc': {
		tooltip: 'Live Doc',
		icon: PageLiveDocIcon,
	},
	whiteboard: {
		tooltip: 'Whiteboard',
		icon: WhiteboardIcon,
	},
	database: {
		tooltip: 'Database',
		icon: DatabaseIcon,
	},
} satisfies Record<string, { tooltip: string; icon: (...args: any[]) => JSX.Element }>;

export type ContentType = keyof typeof contentTypeConfiguration;
